// Libraries
import get from 'lodash/get'

// Models
import Model from 'models/Model'

// Helpers
import { date } from 'helpers/format'

export default class Profile extends Model {
  get id() {
    return this.model.id
  }

  get publishedAt() {
    return date(this.model.published_date, 'MMM dd, yyyy | hh:mma')
  }

  get title() {
    return get(this.model, 'in_app.title', null)
  }

  get content() {
    return get(this.model, 'in_app.content', null)
  }

  get files() {
    return get(this.model, 'in_app.attach_file', [])
  }
}
